import { Modal } from 'antd';

const noop = () => {};

export const confirmUnsavedChanges = ({ onOk, title }) => {
  Modal.confirm({
    title,
    content: 'Ничего не будет сохранено.',
    okText: 'Да',
    cancelText: 'Нет',
    onOk,
    onCancel: noop,
  });
};

export const confirmSaveWithoutWorkerIntervals = ({ onOk, workerNames }) => {
  const names = workerNames.join(', ');
  const isSingleWorker = workerNames.length === 1;

  Modal.confirm({
    title: 'Не задан интервал времени',
    content: isSingleWorker
      ? `Необходимо задать интервал времени работы исполнителя ${names}. Иначе исполнитель не будет сохранен для графика. Сохранить настройку графика без исполнителя?`
      : `Необходимо задать интервал времени работы исполнителей ${names}. Иначе исполнители не будут сохранены для графика. Сохранить настройку графика без исполнителей?`,
    okText: 'Да',
    cancelText: 'Нет',
    onOk,
    onCancel: noop,
  });
};
